import { getGlobalField } from "@/_store/helpers";

export default {
    getFooterLeftItems(footerItems, model) {
        const leftItems = footerItems.filter((x) => x.location === "left");

        return leftItems
            .map((c) => {
                let globalField = { ...getGlobalField(c.screenField) };
                if (Object.keys(globalField).length === 0) return c;

                if (typeof c.value !== "undefined") globalField.value = c.value;
                if (typeof c.dataField !== "undefined")
                    globalField.dataField = c.dataField;
                if (typeof c.label !== "undefined") globalField.label = c.label;
                if (typeof c.format !== "undefined") globalField.format = c.format;
                if (typeof c.fieldType !== "undefined")
                    globalField.fieldType = c.fieldType;
                if (typeof c.length !== "undefined") globalField.length = c.length;
                if (globalField.type === "Decimal") {
                    globalField.label = globalField.label.replace(
                        "(Customer Currency)",
                        `(${model.CurrencyCode})`
                    );
                }
                if (globalField.type === "Decimal") {
                    globalField.label = globalField.label.replace(
                        "(Customer Currency)",
                        `(${model.CurrencyCode})`
                    );
                }
                if (globalField) return globalField;
                else return c;
            })
            .filter((x) => x != null);
    },

    getFooterRightItems(footerItems, model) {
        const rightItems = footerItems.filter(
            (x) =>
                x.location === "right" &&
                (x.hasOwnProperty("visible") ? x.visible : true)
        );

        return rightItems
            .map((c) => {
                let globalField = { ...getGlobalField(c.screenField) };

                if (Object.keys(globalField).length === 0) return c;

                if (typeof c.value !== "undefined") globalField.value = c.value;
                if (typeof c.dataField !== "undefined")
                    globalField.dataField = c.dataField;
                if (typeof c.label !== "undefined") globalField.label = c.label;
                if (typeof c.format !== "undefined") globalField.format = c.format;

                if (globalField.type === "Decimal") {
                    globalField.label = globalField.label.replace(
                        "(Customer Currency)",
                        `(${model.CurrencyCode})`
                    );
                }

                if (globalField) return globalField;
                else return c;
            })
            .filter((x) => x != null);
    },
}